
<div class="card1" *ngIf="containerDisplay === 'ROUNDLIST'">
    <div class="sub-nav-wrapper margin-top-medium" *ngIf="!isSingleCourse">
        <div class="sub-nav">
            <div class="sub-nav-item" [class.active]="roundListTypeDisplay === 'LEADERBOARD'" (click)="roundListTypeDisplay = 'LEADERBOARD'">Leaderboard</div>
            <div class="sub-nav-item" [class.active]="roundListTypeDisplay === 'ALLROUNDS'" (click)="roundListTypeDisplay = 'ALLROUNDS'">Rounds</div>
            <div class="sub-nav-item" [class.active]="roundListTypeDisplay === 'DETAILS'" (click)="roundListTypeDisplay = 'DETAILS'">Details</div>
        </div>
    </div>

    <div *ngIf="!isSingleCourse && roundListTypeDisplay === 'LEADERBOARD'">
        <span (click)="getLeaderboard()" style="font-size: 0.8em;"><img src="../../../../assets/noun-refresh-765048-FFFFFF.png" style="width:10px; margin-right: 6px;" /> Refresh Leaderboard</span>
        <img src="../../../../assets/noun-mobile-rotate-817324-FFFFFF.png" class="hide-on-desktop phone-flip" />
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th style="text-align: left;">
                            Player
                        </th>
                        <th>Score</th>
                        <th class="hide-on-mobile">Rounds Counted</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let l of leaderboard; let i = index">
                        <tr [class.unofficial-row]="isHybridScramble && !isCourseOfficial(l)">
                            <td>{{ courseRank(i) }}</td>
                            <td style="width: 50%; text-align: left;">
                                {{ l.isTeamEvent ? l.teamName : l.individualFirstName + " " + l.individualLastName }}
                                <span class="status-badge unofficial" *ngIf="isHybridScramble && !isCourseOfficial(l)">Unofficial</span>
                                <p class="course-progress hide-on-desktop" *ngIf="isHybridScramble">{{ l.roundsCounted }} of {{ roundsToCount }} rounds</p>
                            </td>
                            <td>
                                {{ formatScore(l.score) }}
                            </td>
                            <td class="hide-on-mobile">
                                {{ l.roundsCounted }} of {{ roundsToCount }}
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <p class="leaderboard-note" *ngIf="isHybridScramble">
            A course score stays unofficial until {{ roundsToCount }} rounds are posted. Unofficial scores are shown, but they are not ranked.
        </p>
    </div>

    <div *ngIf="isSingleCourse || roundListTypeDisplay === 'ALLROUNDS'">
        <img src="../../../../assets/noun-mobile-rotate-817324-FFFFFF.png" class="hide-on-desktop phone-flip" />
        <table>
            <thead>
                <tr>
                    <th>Date</th>
                    <th style="text-align: left;">
                        Player
                    </th>
                    <th>Score</th>
                    <th *ngIf="usingHandicaps" class="hide-on-mobile">Gross Score</th>
                    <th class="hide-on-mobile">Round Counted</th>
                    <th class="hide-on-mobile" *ngIf="isAdmin"></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let r of allRounds; let i = index">
                    <tr>
                        <td>{{ formatLocalDateTime(r.round.createdDateUTC) }}</td>
                        <td style="width: 50%; text-align: left;">
                            {{ roundLabel(r.round) }}
                        </td>
                        <td class="hide-on-desktop">
                                {{ r.round.score }}<span *ngIf="r.round.scoreUsedOnLeaderboard"><sup>*</sup></span>
                            </td>
                        <td class="hide-on-mobile">
                            {{ r.round.score }}
                        </td>
                        <td *ngIf="usingHandicaps" class="hide-on-mobile">{{ r.round.grossScore }}</td>
                        <td class="hide-on-mobile">
                            <img style="width: 25px;" src="../../../../assets/noun-check-circle-6630733-71D358.png" *ngIf="r.round.scoreUsedOnLeaderboard" />
                        </td>
                        <td class="hide-on-mobile" *ngIf="isAdmin">
                            <img src="../../../../assets/noun-trash-7207989-FFFFFF.png" style="width: 35px;" *ngIf="!r.isConfirming" (click)="r.isConfirming = true"/>
                            <span *ngIf="r.isConfirming">
                                <p>Are you sure?</p>
                                <img src="../../../../assets/noun-check-circle-6630733-71D358.png" style="width:15px; margin-left: 3px; margin-right: 10px;" (click)="deleteRound(r)" />
                                <img src="../../../../assets/noun-x-circle-4815624-FF001C.png" style="width:15px;" (click)="r.isConfirming = false" />
                            </span>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <div class="hide-on-desktop" *ngIf="allRounds.length > 0" style="font-size: 0.7em;"><sup>*</sup> Score is used in the leaderboard calculation.</div>
    </div>

    <div *ngIf="!isSingleCourse && roundListTypeDisplay === 'DETAILS'">
        <app-week-details [leagueWeek]="leagueWeek" [league]="league" [canEdit]="canEditWeek" (edit)="requestEditWeek()"></app-week-details>
    </div>

    <button *ngIf="canPostRound" (click)="postRound()" >Post a Round</button>
    <div class="error" *ngIf="!loggedInPlayerHasPaid && !hidePostButton && !isEventOver">You are not able to post rounds until your entry fee has been sent to the Commish he has marked you as paid.</div>
</div>

<app-post-individual-round *ngIf="containerDisplay === 'POSTINDIVIDUALROUND'" [leagueWeek]="leagueWeek" [loggedInPlayerId]="loggedInPlayerId" [paidPlayers]="paidPlayers" (scoresPosted)="scoresPosted()"></app-post-individual-round>
<app-post-team-round *ngIf="containerDisplay === 'POSTTEAMROUND'" [leagueWeek]="leagueWeek" [loggedInPlayerId]="loggedInPlayerId" [paidPlayers]="paidPlayers" (scoresPosted)="scoresPosted()"></app-post-team-round>
<app-post-scramble-round *ngIf="containerDisplay === 'POSTSCRAMBLEROUND'" [leagueWeek]="leagueWeek" [loggedInPlayerId]="loggedInPlayerId" [paidPlayers]="paidPlayers" [useHandicaps]="!!league?.useHandicaps" (scoresPosted)="scoresPosted()"></app-post-scramble-round>

<button type="button" class="back-link" (click)="backToRoundList()" *ngIf="containerDisplay != 'ROUNDLIST'">Back</button>
